import { Referrals } from '../models/referrals';
import { Action } from '@ngrx/store';

export const REFERRALS_ACTION_FAIL = '[Referrals] Referrals Action Fail';
export const REFERRALS_ACTION_SUCCESS = '[Referrals] Referrals Action Success';
export const CLEAR_REFERRALS = '[Referrals] Clear Referrals';
export const REFERRALS_CLEAR_ERRORS = '[Referrals] Clear Referrals Errors';
export const LOAD_REFERRALS = '[Referrals] Load Referrals';
export const LOAD_REFERRALS_SUCCESS = '[Referrals] Load Referrals Success';

export class ReferralsActionFail implements Action {
  readonly type = REFERRALS_ACTION_FAIL;

  constructor(public payload: any) {}
}

export class ReferralsActionSuccess implements Action {
  readonly type = REFERRALS_ACTION_SUCCESS;

  constructor(public payload: any) {}
}

export class ClearReferrals implements Action {
  readonly type = CLEAR_REFERRALS;
}

export class ReferralsClearErrors implements Action {
  readonly type = REFERRALS_CLEAR_ERRORS;
}

// REFERRALS
export class LoadReferrals implements Action {
  readonly type = LOAD_REFERRALS;

  constructor(public payload: { id: number }) {}
}

export class LoadReferralsSuccess implements Action {
  readonly type = LOAD_REFERRALS_SUCCESS;

  constructor(public payload: Referrals) {}
}

export type All =
  | ReferralsActionFail
  | ReferralsActionSuccess
  | ClearReferrals
  | ReferralsClearErrors
  | LoadReferrals
  | LoadReferralsSuccess;
